import { faCheck, faDiagramProject, faEye, faFilter, faFlagCheckered, faTag, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { loadList, loadLabelList, loadUserList, loadCheckList, filterLabel, filterProject, filterUser, cleanFilter } from '../../../../reducers/models/taskRTracker/taskRTrackerList';

import { useDispatch, useSelector } from "react-redux";
import DisplayTable from "./DisplayTable";
import FilterDate from "../../../../components/filter/FilterDate";
import InfoNoData from "../../../../components/global/InfoNoData";
import TabBar from "../../../../components/ui/TabBar";
import ModalUpdate from "./ModalUpdate";
import axios from "axios";
import FilterUniversal from "../../../../components/filter/FilterUniversal";
import ErrorAdd from "../../../../util/ErrorAdd";

function Index() {

    const stateList = useSelector((state) => state.taskRTrackerList);//Редюсер задач
    const stateUserList = useSelector((state) => state.userList);//Пользователи

    //TAB START
    const [tab, setTab] = useState([
        { id_tab: 0, name: "Исполнитель", icon: faCheck, showCount: false, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 1, name: "Наблюдатель", icon: faEye, showCount: false, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 2, name: "Все задачи", icon: faUsers, showCount: false, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 3, name: "Выполненные", icon: faFlagCheckered, showCount: false, loading: false, loading1: false, loading2: false, loading3: false }
    ]);

    const [filterShow, setFilterShow] = useState(false);
    const [tabSelected, setTabSelected] = useState(0);


    function tabHandler(id_tab) {
        setTabSelected(id_tab)

        if (id_tab === 2) {
            loadAllTasks();
        }
        if (id_tab === 3) {
            loadCompletedTasks(completedDateStart, completedDateEnd);
        }
    }
    //TAB END
    const dispatch = useDispatch()

    useEffect(() => {
        if (tab.filter(a => a.id_tab === tabSelected & a.loading1 === false & a.loading2 === false & a.loading3 === false & a.loading === true).length > 0) {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === tabSelected) {
                    return { ...item, loading: false }
                }
                else {
                    return item;
                }
            }))
        }
    }, [tab, tabSelected]);

    //Подгрузка данных необходимых для задач
    function loadDataForTask(id_tasks_r, id_tasks_r_tracker, id_tab) {
        //Подгружаем метки
        axios.get('/api_tracker/taskR/widgetLabelListByTasks', { params: { ID_Tasks: id_tasks_r.join(',') } })
            .then((resLabel) => {
                if (resLabel.data.Status === 1) {
                    dispatch(loadLabelList({ list: resLabel.data.Data, id_tab: id_tab }));
                }
                else {
                    //setLog(res.data.Error);
                }

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading1: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                //setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading1: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });

        //Подгружаем чек-боксы
        axios.get('/api_tracker/taskR/widgetTrackerCheckListByTasks', { params: { ID_Tasks: id_tasks_r_tracker.join(',') } })
            .then((resCheckList) => {
                if (resCheckList.data.Status === 1) {
                    dispatch(loadCheckList({ list: resCheckList.data.Data, id_tab: id_tab }));
                }
                else {
                    //setLog(res.data.Error);
                }

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading2: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                //setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading2: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });

        //Подгружаем пользователей
        axios.get('/api_tracker/taskR/trackerUserListByTasks', { params: { ID_Tasks: id_tasks_r_tracker.join(',') } })
            .then((resUser) => {
                if (resUser.data.Status === 1) {
                    dispatch(loadUserList({ list: resUser.data.Data/*.filter(a => a.Completed === false)*/, id_tab: id_tab }));
                }
                else {
                    //setLog(res.data.Error);
                }

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading3: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                //setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading3: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });
    }

    useEffect(() => {
        //Загружаем активные задачи "Исполнитель"
        if (stateList.listLoaded.filter(a => a.id_tab === 0).length === 0) {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === 0) {
                    return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
                }
                else {
                    return item;
                }
            }))

            axios.get('/api_tracker/taskR/trackerListActiveByAction', { params: { ID_Action: 2 } })
                .then((resTask) => {
                    dispatch(loadList({ list: resTask.data.Data, id_tab: 0 }));

                    //Заполняем ИД задач                   
                    const id_tasks_r_tracker = resTask.data.Data.map((item) => {
                        return item.ID;
                    })
                    //Заполняем ИД трекера задач
                    const id_tasks_r = resTask.data.Data.map((item) => {
                        return item.ID_TaskR;
                    })

                    if (id_tasks_r.length > 0) {
                        loadDataForTask(id_tasks_r, id_tasks_r_tracker, 0);
                    }
                    else {
                        setTab(tab_ => tab_.map(item => {
                            if (item.id_tab === 0) {
                                return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                            }
                            else {
                                return item;
                            }
                        }))
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });

        }
        //Загружаем активные задачи "Наблюдатель"
        if (stateList.listLoaded.filter(a => a.id_tab === 1).length === 0) {

            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === 1) {
                    return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
                }
                else {
                    return item;
                }
            }))

            axios.get('/api_tracker/taskR/trackerListActiveByAction', { params: { ID_Action: 1 } })
                .then((resTask) => {
                    dispatch(loadList({ list: resTask.data.Data, id_tab: 1 }));

                    //Заполняем ИД задач                   
                    const id_tasks_r_tracker = resTask.data.Data.map((item) => {
                        return item.ID;
                    })
                    //Заполняем ИД трекера задач
                    const id_tasks_r = resTask.data.Data.map((item) => {
                        return item.ID_TaskR;
                    })

                    if (id_tasks_r.length > 0) {
                        loadDataForTask(id_tasks_r, id_tasks_r_tracker, 1);
                    }
                    else {
                        setTab(tab_ => tab_.map(item => {
                            if (item.id_tab === 1) {
                                return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                            }
                            else {
                                return item;
                            }
                        }))
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });

        }
    }, []);

    useEffect(() => {
        //Обновляем счетчик задач
        setTab(tab_ => tab_.map(t => {
            if (t.id_tab === 0) {
                return { ...t, count: stateList.list.filter(a => a.id_tab === 0).length }
            }
            else if (t.id_tab === 1) {
                return { ...t, count: stateList.list.filter(a => a.id_tab === 1).length }
            }
            else {
                return t;
            }
        }))

    }, [stateList.list]);

    const [filterLabelList, setFilterLabelList] = useState([]);//Данные для фильтра с метками.
    const [filterUserList, setFilterUserList] = useState([]);//Данные для фильтра с пользователями.

    useEffect(() => {

        var filter_list = [];

        tab.map(tab => {
            stateList.list.filter(a => a.id_tab === tab.id_tab).map(task => {
                stateList.listLabel.filter(a => a.ID_Item === task.ID_TaskR).map(label => {
                    if (filter_list.filter(a => a.id === label.ID_Label & a.id_tab === tab.id_tab).length === 0) {
                        filter_list.push({
                            id_tab: tab.id_tab
                            , id: label.ID_Label
                            , name: label.Name
                            , color: label.Color
                            , count: 5
                        })
                    }
                })
            })
        })
        setFilterLabelList(filter_list);

        //Преобразовываем метки в нужный формат
        /*stateList.listLabel.map((item) => {
            if (filter_list.filter(a => a.id === item.ID_Label & a.id_tab === item.id_tab).length == 0) {
                filter_list.push({ id: item.ID_Label, id_tab: item.id_tab, name: item.Name, color: item.Color, count: stateList.listLabel.filter(a => a.id_tab == item.id_tab & a.ID_Label == item.ID_Label).length })
            }
        })

        setFilterLabelList(filter_list);*/

    }, [stateList.listLabel]);

    useEffect(() => {

        var filter_list = [];

        //Преобразовываем пользователей в нужный формат
        stateList.listUser.map((item) => {
            if (filter_list.filter(a => a.id === item.ID_User & a.id_tab === item.id_tab).length == 0) {
                const name_ = stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0 ? stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User : 'Не найден...'
                filter_list.push({ id: item.ID_User, id_tab: item.id_tab, name: name_, count: stateList.listUser.filter(a => a.id_tab === item.id_tab & a.ID_User === item.ID_User).length })
            }
        })

        setFilterUserList(filter_list);

    }, [stateList.listUser]);

    /*************************START ВСЕ ЗАДАЧИ***********************************/
    function loadAllTasks() {

        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === 2) {
                return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
            }
            else {
                return item;
            }
        }))

        axios.get('/api_tracker/taskR/trackerListActiveAll')
            .then((resTask) => {
                dispatch(loadList({ list: resTask.data.Data, id_tab: 2 }));

                //Заполняем ИД задач                   
                const id_tasks_r_tracker = resTask.data.Data.map((item) => {
                    return item.ID;
                })
                //Заполняем ИД трекера задач
                const id_tasks_r = resTask.data.Data.map((item) => {
                    return item.ID_TaskR;
                })

                if (id_tasks_r.length > 0) {
                    loadDataForTask(id_tasks_r, id_tasks_r_tracker, 2);
                }
                else {
                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === 2) {
                            return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                        }
                        else {
                            return item;
                        }
                    }))
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });

    }
    /**************************END ВСЕ ЗАДАЧИ************************************/
    /*********************START ЗАВЕРШЕННЫЕ ЗАДАЧИ*******************************/
    const [completedDateStart, setCompletedDateStart] = useState(null);
    const [completedDateEnd, setCompletedDateEnd] = useState(null);

    //Событие изменения даты
    function completedDateHandler(dateStart, dateEnd) {
        setCompletedDateStart(dateStart);
        setCompletedDateEnd(dateEnd);

        if (tabSelected === 3) {
            loadCompletedTasks(dateStart, dateEnd);
        }
    }
    //Загрузит список завершенных задач
    function loadCompletedTasks(dateStart, dateEnd) {

        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === 3) {
                return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
            }
            else {
                return item;
            }
        }))

        axios.get('/api_tracker/taskR/TrackerListCompleted', { params: { Date_Start: dateStart, Date_End: dateEnd } })
            .then((resTask) => {
                dispatch(loadList({ list: resTask.data.Data, id_tab: 3 }));

                //Заполняем ИД задач                   
                const id_tasks_r_tracker = resTask.data.Data.map((item) => {
                    return item.ID;
                })
                //Заполняем ИД трекера задач
                const id_tasks_r = resTask.data.Data.map((item) => {
                    return item.ID_TaskR;
                })

                if (id_tasks_r.length > 0) {
                    loadDataForTask(id_tasks_r, id_tasks_r_tracker, 3);
                }
                else {
                    dispatch(cleanFilter({ id_tab: 3 }));

                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === 3) {
                            return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                        }
                        else {
                            return item;
                        }
                    }))
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });

    }
    /*********************END ЗАВЕРШЕННЫЕ ЗАДАЧИ*******************************/
    /***********************START ФИЛЬТР МЕТОК*********************************/
    const [filterLabelSelected, setFilterLabelSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }, { id_tab: 2, val: -1 }, { id_tab: 3, val: -1 }]);

    function filterLabelHandler(id_label, id_tab) {

        const val_ = filterLabelSelected.filter(a => a.id_tab === id_tab)[0].val === id_label ? -1 : id_label;

        const list = filterLabelSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterLabel({ id_tab: id_tab, id_label: val_ }));
        setFilterLabelSelected(list);
    }
    /************************END ФИЛЬТР МЕТОК**********************************/
    /**********************START ФИЛЬТР ПРОЕКТОВ*******************************/
    const [filterProjectSelected, setFilterProjectSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }, { id_tab: 2, val: -1 }, { id_tab: 3, val: -1 }]);

    function filterProjectHandler(id_project, id_tab) {

        const val_ = filterProjectSelected.filter(a => a.id_tab === id_tab)[0].val === id_project ? -1 : id_project;

        const list = filterProjectSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterProject({ id_tab: id_tab, id_project: val_ }));
        setFilterProjectSelected(list);
    }
    /***********************END ФИЛЬТР ПРОЕКТОВ********************************/
    /********************START ФИЛЬТР ПОЛЬЗОВАТЕЛЕЙ****************************/
    const [filterUserSelected, setFilterUserSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }, { id_tab: 2, val: -1 }, { id_tab: 3, val: -1 }, { id_tab: 4, val: -1 }, { id_tab: 5, val: -1 }]);

    function filterUserHandler(id_user, id_tab) {

        const val_ = filterUserSelected.filter(a => a.id_tab === id_tab)[0].val === id_user ? -1 : id_user;

        const list = filterUserSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }

        })
        dispatch(filterUser({ id_tab: id_tab, id_user: val_ }));
        setFilterUserSelected(list);
    }
    /*********************END ФИЛЬТР ПОЛЬЗОВАТЕЛЕЙ*****************************/

    /**********************START ИЗМЕНЕНИЕ ЗАДАЧИ******************************/
    const [modalShow, setModalShow] = useState(false);
    const [model, setModel] = useState({});

    function editHandler(model) {
        setModel(model);
        setModalShow(true);

        //Сделает задачу просмотренной
        if (model.Viewed != true & (model.id_tab === 0 || model.id_tab === 1)) {
            axios.post('/api_tracker/taskR/trackerUserView', { ID_TaskR_Tracker: model.ID })
                .then((res) => {
                    //dispatch(view({ id_task: model.ID }));
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });

        }
    }
    /***********************END ИЗМЕНЕНИЕ ЗАДАЧИ*******************************/

    return (
        <div className='admin_content'>
            {modalShow === true && stateList.list.filter(a => a.ID === model.ID).length > 0 && (
                <ModalUpdate show={modalShow} onHide={() => setModalShow(false)} model={stateList.list.filter(a => a.ID === model.ID)[0]} />
            )}
            <div>
                <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} filterShow={filterShow} setFilterShow={setFilterShow} showFilter={true}/*setAddShow={setModalAddShow}*/ />
            </div>
            {tab.map(tab => (
                <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>
                    <div className={filterShow === false ? "d-none" : ""}>
                        <div className="filter-container mt-10">
                            <div className="filter-title"><FontAwesomeIcon icon={faFilter} />ФИЛЬТР</div>
                            {tab.id_tab === 3 && (
                                <FilterDate defaultVal={4} changHandler={completedDateHandler} />
                            )}
                            <FilterUniversal filterName="Проекты" filterIcon={faDiagramProject} list={stateList.filterProject.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterProjectHandler} selected={filterProjectSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                            <FilterUniversal filterName="Метки" filterIcon={faTag} list={filterLabelList.filter(a => a.id_tab === tab.id_tab)} show_count={false} id_filter={tab.id_tab} clickHandler={filterLabelHandler} selected={filterLabelSelected.filter(a => a.id_tab === tab.id_tab)[0].val} />
                            {tab.id_tab === 2 && (
                                <FilterUniversal filterName="Ответственные" filterIcon={faUser} list={filterUserList.filter(a => a.id_tab === tab.id_tab)} show_count={true} id_filter={tab.id_tab} clickHandler={filterUserHandler} selected={filterUserSelected.filter(a => a.id_tab === tab.id_tab)[0].val} />
                            )}
                        </div>
                    </div>
                    {tab.loading === true ? (<div className="loader_01 mt-30"></div>)
                        : (
                            stateList.list.filter(a => a.id_tab === tab.id_tab & a.filter_label === 0 & a.filter_project === 0 & a.filter_user === 0).length === 0 ? (
                                <InfoNoData text="Нет задач" />
                            ) : (
                                <DisplayTable key={0}
                                    editHandler={editHandler}
                                    list={stateList.list.filter(a => a.id_tab === tab.id_tab & a.filter_label === 0 & a.filter_project === 0 & a.filter_user === 0)}
                                    listLabel={stateList.listLabel}
                                    listCheckList={stateList.listCheckList.filter(a => a.id_tab === tab.id_tab)}
                                    idTab={tab.id_tab}
                                />
                            )
                        )}
                </div>
            ))}
        </div>
    );
}

export default Index;
